import React, { useState } from "react";
import "./Admin.scss";
import { Button, Divider, Layout, Menu, MenuProps } from "antd";
import {
  PieChartOutlined,
  ProductOutlined,
  ShoppingOutlined,
  LogoutOutlined,
  PieChartFilled,
  ProductFilled,
  ShoppingFilled,
} from "@ant-design/icons";
import Helpers from "@utils/Helpers";
import Sider from "antd/es/layout/Sider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser as faUserSolid } from "@fortawesome/free-solid-svg-icons";
import { faUser as faUserRegular } from "@fortawesome/free-regular-svg-icons";
import AdminUserManagement from "@components/AdminUserManagement/AdminUserManagement";
import AdminDashboard from "@components/AdminDashboard/AdminDashboard";

type MenuItem = Required<MenuProps>["items"][number];

const Admin: React.FC = () => {
  const [selectedKey, setSelectedKey] = useState<string>("1");

  const handleTabSelect = (key: string) => {
    setSelectedKey(key);
  };

  const adminTabMenu: MenuItem[] = [
    {
      key: "1",
      label: "Dashboard",
      icon: selectedKey === "1" ? <PieChartFilled /> : <PieChartOutlined />,
    },
    {
      key: "2",
      label: "Product Management",
      icon: selectedKey === "2" ? <ProductFilled /> : <ProductOutlined />,
    },
    {
      key: "3",
      label: "User Management",
      icon: (
        <FontAwesomeIcon
          icon={selectedKey === "3" ? faUserSolid : faUserRegular}
        />
      ),
    },
    {
      key: "4",
      label: "Order Management",
      icon: selectedKey === "4" ? <ShoppingFilled /> : <ShoppingOutlined />,
    },
  ];

  return (
    <div className="Admin">
      <Sider width={"fit-content"} theme="light" className="sider">
        <div className="sider-item">
          <div className="user">
            Hi, Admin
            <img
              src={Helpers.getImageFrontPage("store1")}
              alt="avatar"
              width={52}
            />
          </div>

          <Divider />

          <Menu
            className="menu"
            mode="inline"
            selectedKeys={[selectedKey]}
            onSelect={({ key }) => handleTabSelect(key)}
            items={adminTabMenu}
          />
        </div>
        <div className="footer">
          <Button className="logout-btn" type="primary" danger>
            <LogoutOutlined /> Log Out{" "}
          </Button>
        </div>
      </Sider>
      <Layout className="content">
        {selectedKey === "1" && <AdminDashboard />}
        {selectedKey === "3" && <AdminUserManagement />}
      </Layout>
    </div>
  );
};

export default Admin;
